/* This is used to for the country code part.
 * 0 represents that we are skipping the country code because we are inside New Zealand.
 * Ideally we should find a way to include international prefixes too, so international numbers can be properly supported.
 */

// Other country prefixes
const additionalCountryPrefixes: string[] = ['61'];
// New Zealand landline (national) prefixes ("base" means we are excluding the country prefix).
const baseLandlinePrefixes: string[] = ['03', '04', '06', '07', '09'];
// New Zealand mobile (national) prefixes.
const baseMobilePrefixes: string[] = [
    '020',
    '021',
    '022',
    '026',
    '027',
    '028',
    '029'
];
// Free call number prefixes
const baseFreeCallNumber: string[] = ['0508', '0800'];

const OTHER_COUNTRY_PHONE_NUMBER_MIN_LENGTH = 9;
const OTHER_COUNTRY_PHONE_NUMBER_MAX_LENGTH = 13;
const HOME_PHONE_NUMBER_MIN_LENGTH = 8;
const HOME_PHONE_NUMBER_MAX_LENGTH = 13;
const MOBILE_PHONE_NUMBER_MIN_LENGTH = 9;
const MOBILE_PHONE_NUMBER_MAX_LENGTH = 12;
const FREE_CALL_PHONE_NUMBER_MIN_LENGTH = 9;
const FREE_CALL_MOBILE_PHONE_NUMBER_MAX_LENGTH = 11;

const otherCountryPhoneNumberSuffixMinLength =
    OTHER_COUNTRY_PHONE_NUMBER_MIN_LENGTH - additionalCountryPrefixes[0].length;
const otherCountryPhoneNumberSuffixMaxLength =
    OTHER_COUNTRY_PHONE_NUMBER_MAX_LENGTH - additionalCountryPrefixes[0].length;
export const OTHER_COUNTRY_PHONE_NUMBER_REGEX = `^(${additionalCountryPrefixes.join(
    '|'
)})\\d{${otherCountryPhoneNumberSuffixMinLength},${otherCountryPhoneNumberSuffixMaxLength}}$`;

const homePhoneSuffixMinLength =
    HOME_PHONE_NUMBER_MIN_LENGTH - baseLandlinePrefixes[0].length;
const homePhoneSuffixMaxLength =
    HOME_PHONE_NUMBER_MAX_LENGTH - baseLandlinePrefixes[0].length;
export const HOME_PHONE_NUMBER_REGEX = `^(${baseLandlinePrefixes.join(
    '|'
)})\\d{${homePhoneSuffixMinLength},${homePhoneSuffixMaxLength}}$`;

const mobilePhoneSuffixMinLength =
    MOBILE_PHONE_NUMBER_MIN_LENGTH - baseMobilePrefixes[0].length;
const mobilePhoneSuffixMaxLength =
    MOBILE_PHONE_NUMBER_MAX_LENGTH - baseMobilePrefixes[0].length;
export const MOBILE_PHONE_NUMBER_REGEX = `^(${baseMobilePrefixes.join(
    '|'
)})\\d{${mobilePhoneSuffixMinLength},${mobilePhoneSuffixMaxLength}}$`;

const freeCallPhoneNumberSuffixMinLength =
    FREE_CALL_PHONE_NUMBER_MIN_LENGTH - baseFreeCallNumber[0].length;
const freeCallPhoneNumberSuffixMaxLength =
    FREE_CALL_MOBILE_PHONE_NUMBER_MAX_LENGTH - baseFreeCallNumber[0].length;
export const FREE_CALL_PHONE_NUMBER_REGEX = `^(${baseFreeCallNumber.join(
    '|'
)})\\d{${freeCallPhoneNumberSuffixMinLength},${freeCallPhoneNumberSuffixMaxLength}}$`;
